import { displayWaist } from './waistUtils';

export default function ManagedWaistTable({ users, onOpenModal }) {
  return <div className="table-responsive"><table className="table table-bordered table-striped align-middle text-center"><thead><tr>
    <th>帳號</th><th>姓名</th><th>最新腰圍 (cm)</th><th>最近 10 筆平均 (cm)</th><th>最新測量時間</th><th>操作</th>
  </tr></thead><tbody>{users.map(u => <tr key={u.userId}>
    <td>{u.account}</td><td>{u.name}</td><td>{u.latestWaistInCm == null ? '-' : displayWaist(u.latestWaistInCm)}</td><td>{u.avgWaistInCm == null ? '-' : displayWaist(u.avgWaistInCm)}</td><td>{u.latestWaistRecordedAt?.replace('T', ' ').slice(0, 16) || '-'}</td>
    <td><div className="d-grid gap-1"><button className="btn btn-sm btn-primary" onClick={() => onOpenModal('waist', u)}>新增紀錄</button><button className="btn btn-sm btn-secondary" onClick={() => onOpenModal('waistHistory', u)}>歷史紀錄</button></div></td>
  </tr>)}</tbody></table></div>;
}
